(function () {
  var root = document.getElementById('mav-exit');
  if (!root) return;

  var form   = document.getElementById('mavExitForm');
  var btn    = document.getElementById('mavExitSubmit');
  var errBox = document.getElementById('mavExitError');

  var STORE_KEY  = 'mav_exit_v1';
  var ATTR_KEY   = 'mav_attr';
  var SESSION_KEY= 'mav_exit_seen';
  var COOLDOWN_DAYS = 14;

  /* Shopify requires a syntactically valid contact[email]. When someone gives
     a phone but no email we have to supply something, and it must be a real,
     resolvable address: the old fallback built one on a "no-email" subdomain
     that does not exist, which put a dead reply-to on every phone-only
     enquiry. The body says plainly that no email was supplied. */
  var NO_EMAIL_ADDRESS = 'info@mavhire.co.uk';

  var params = new URLSearchParams(window.location.search);
  var forced = params.get('mavexit') === '1';
  var shown = false;
  var armed = false;
  var lastFocus = null;

  function ss(fn, fallback) { try { return fn(); } catch (e) { return fallback; } }

  /* ----------------------------------------------------------
     Should this visitor see it at all?
  ---------------------------------------------------------- */
  function suppressed() {
    if (forced) return false;
    if (window.Shopify && window.Shopify.designMode) return true;

    // Checkout / cart / account safety net on top of the Liquid guard.
    var p = window.location.pathname;
    if (/^\/(checkout|cart|account|apps|tools)(\/|$)/.test(p)) return true;

    var state = ss(function () {
      return JSON.parse(localStorage.getItem(STORE_KEY) || '{}');
    }, {}) || {};
    if (state.submitted) return true;
    if (state.dismissedAt && (Date.now() - state.dismissedAt) < COOLDOWN_DAYS * 86400000) return true;
    // Tapped Call or WhatsApp in the popup: same 14-day cooldown as closing it.
    if (state.contactedAt && (Date.now() - state.contactedAt) < COOLDOWN_DAYS * 86400000) return true;
    if (ss(function () { return sessionStorage.getItem(SESSION_KEY); })) return true;

    // Already filling in a quote form on the page? Leave them alone.
    var live = document.querySelectorAll('form[action*="/contact"] input, form[action*="/contact"] textarea, form[action*="/contact"] select');
    for (var i = 0; i < live.length; i++) {
      var el = live[i];
      if (el.form === form) continue;
      if (el.type === 'hidden') continue;
      if (el.value && el.value.trim()) return true;
    }
    return false;
  }

  function remember(patch) {
    var state = ss(function () {
      return JSON.parse(localStorage.getItem(STORE_KEY) || '{}');
    }, {}) || {};
    for (var k in patch) { if (Object.prototype.hasOwnProperty.call(patch, k)) state[k] = patch[k]; }
    ss(function () { localStorage.setItem(STORE_KEY, JSON.stringify(state)); });
  }

  /* ----------------------------------------------------------
     Open / close
  ---------------------------------------------------------- */
  function open() {
    if (shown || suppressed()) return;
    shown = true;
    disarm();
    ss(function () { sessionStorage.setItem(SESSION_KEY, '1'); });
    remember({ shownAt: Date.now() });

    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('mav-exit-open');
    document.body.classList.add('mav-exit-open');

    var first = document.getElementById('mav-exit-name');
    var panel = root.querySelector('.mav-exit__panel');
    // Focusing an input on mobile pops the keyboard over the panel, so only
    // move focus straight into the form on pointer-based devices. On touch we
    // focus the dialog itself, which announces it without opening a keyboard.
    var target = (first && window.matchMedia('(min-width: 750px)').matches) ? first : panel;
    if (target) setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) {} }, 60);

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'exit_popup_shown', { page_path: window.location.pathname });
    }
  }

  function close(byUser) {
    root.hidden = true;
    document.documentElement.classList.remove('mav-exit-open');
    document.body.classList.remove('mav-exit-open');
    if (byUser) remember({ dismissedAt: Date.now() });
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-mav-exit-close]')) { e.preventDefault(); close(true); return; }
    // Call / WhatsApp buttons: the link does its job (mav-contact-tracking.js
    // records the tap as an "exit popup" contact click); remember it so the
    // popup stays away for the usual 14 days.
    if (e.target.closest('[data-mav-exit-quick]')) remember({ contactedAt: Date.now() });
  });

  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { close(true); return; }
    if (e.key !== 'Tab') return;

    // Keep tabbing inside the dialog while it's open.
    var panel = root.querySelector('.mav-exit__panel');
    var items = panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([tabindex="-1"]), select, textarea');
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ----------------------------------------------------------
     Triggers
  ---------------------------------------------------------- */
  var startedAt = Date.now();
  var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var READY_MS = isTouch ? 15000 : 8000;
  var guardHref = '';
  var guardArmed = false;

  function onMouseOut(e) {
    if (e.clientY > 4) return;
    if (e.relatedTarget || e.toElement) return;
    if (Date.now() - startedAt < READY_MS) return;
    open();
  }

  // Mobile: a quick flick back up the page after they've read some of it.
  var lastY = window.pageYOffset || 0;
  var lastT = Date.now();
  var deepest = 0;
  function onScroll() {
    var y = window.pageYOffset || 0;
    var t = Date.now();
    if (y > deepest) deepest = y;
    var dy = lastY - y;
    var dt = t - lastT || 1;
    lastY = y; lastT = t;
    if (Date.now() - startedAt < READY_MS) return;
    if (deepest < 500) return;            // they never really engaged
    if (y > 260) return;                  // only near the top, heading for the address bar
    if (dy / dt < 1.1) return;            // not a fast flick upwards
    open();
  }

  function armBackGuard() {
    if (guardArmed || !isTouch) return;
    if (!window.history || !window.history.pushState) return;
    guardHref = window.location.href;
    try { window.history.pushState({ mavExitGuard: true }, '', window.location.href); } catch (e) { return; }
    guardArmed = true;
  }

  function onPopState() {
    if (!guardArmed || shown) return;
    // If the URL moved on (collection filters, search facets), this isn't
    // our guard being popped — re-arm against the new URL instead.
    if (window.location.href !== guardHref) {
      guardArmed = false;
      armBackGuard();
      return;
    }
    guardArmed = false;
    open();
  }

  function disarm() {
    document.removeEventListener('mouseout', onMouseOut);
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('popstate', onPopState);
  }

  function arm() {
    if (armed || suppressed()) return;
    armed = true;
    if (isTouch) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('popstate', onPopState);
      setTimeout(armBackGuard, READY_MS);
    } else {
      document.addEventListener('mouseout', onMouseOut);
    }
  }

  if (forced) {
    setTimeout(open, 400);
  } else {
    setTimeout(arm, 1200);
  }

  /* ----------------------------------------------------------
     Attribution — same session key the contact page writes
  ---------------------------------------------------------- */
  (function fillAttribution() {
    var stored = ss(function () {
      return JSON.parse(sessionStorage.getItem(ATTR_KEY) || '{}');
    }, {}) || {};
    var keys = ['utm_source','utm_campaign','utm_adgroup','utm_term','utm_content','gclid'];
    var fresh = {}, hasFresh = false;
    keys.forEach(function (k) {
      var v = params.get(k);
      if (v) { fresh[k] = v.slice(0, 300); hasFresh = true; }
    });
    if (hasFresh) {
      fresh.landing_page = window.location.href.split('#')[0];
      fresh.referrer = document.referrer || '';
      stored = fresh;
      ss(function () { sessionStorage.setItem(ATTR_KEY, JSON.stringify(stored)); });
    } else if (!stored.landing_page) {
      stored.landing_page = window.location.href.split('#')[0];
      stored.referrer = document.referrer || '';
      ss(function () { sessionStorage.setItem(ATTR_KEY, JSON.stringify(stored)); });
    }
    root.querySelectorAll('[data-mav-attr]').forEach(function (el) {
      el.value = stored[el.getAttribute('data-mav-attr')] || '';
    });
  })();

  /* ----------------------------------------------------------
     Date can't be in the past
  ---------------------------------------------------------- */
  (function setDateFloor() {
    var d = document.getElementById('mav-exit-date');
    if (!d) return;
    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    d.min = now.toISOString().slice(0, 10);
  })();

  /* ----------------------------------------------------------
     Submit — honeypot, no-email fallback, composed body
  ---------------------------------------------------------- */
  function val(id) {
    var el = document.getElementById(id);
    return el && el.value ? el.value.trim() : '';
  }

  function fail(msg, focusId) {
    if (errBox) { errBox.textContent = msg; errBox.hidden = false; }
    var el = focusId && document.getElementById(focusId);
    if (el) { el.classList.add('is-invalid'); try { el.focus(); } catch (e) {} }
  }

  form.addEventListener('input', function (e) {
    if (e.target.classList) e.target.classList.remove('is-invalid');
    if (errBox) errBox.hidden = true;
  });

  form.addEventListener('submit', function (e) {
    // Honeypot. See the comment on the field in mav-exit-intent.liquid — this
    // must only ever catch bots, never a visitor using autofill.
    var hp = document.getElementById('mav-exit-hpref');
    if (hp && hp.value) { e.preventDefault(); return; }

    if (!val('mav-exit-name'))  { e.preventDefault(); fail('Please add your name so we know who we’re quoting for.', 'mav-exit-name'); return; }
    if (val('mav-exit-phone').replace(/\D/g, '').length < 7) {
      e.preventDefault(); fail('Please add a phone number we can reach you on.', 'mav-exit-phone'); return;
    }
    var emailEl = document.getElementById('mav-exit-email');
    if (emailEl && emailEl.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value.trim())) {
      e.preventDefault(); fail('That email address doesn’t look right — or leave it blank and we’ll call.', 'mav-exit-email'); return;
    }

    // Shopify requires a valid contact[email]
    var usedFallback = false;
    if (emailEl && !emailEl.value.trim()) {
      emailEl.value = NO_EMAIL_ADDRESS;
      usedFallback = true;
    }

    // Shopify also validates contact[body] — never let it be blank
    var lines = [];
    lines.push('Sent from the exit popup.');
    lines.push('Page: ' + document.title + ' (' + window.location.pathname + ')');
    lines.push('');
    lines.push('Event date: ' + (val('mav-exit-date') || 'not given'));
    lines.push('');
    lines.push('Brief:');
    lines.push(val('mav-exit-needs') || 'Not specified — needs a call.');
    lines.push('');
    lines.push('Contact: ' + val('mav-exit-phone') + (usedFallback
      ? ' (phone only — no email supplied)'
      : ' / ' + val('mav-exit-email')));
    var bodyEl = document.getElementById('mav-exit-body');
    if (bodyEl) bodyEl.value = lines.join('\n');

    // Strip empty attribution fields so they don't clutter the email
    root.querySelectorAll('[data-mav-attr]').forEach(function (el) {
      if (!el.value) el.removeAttribute('name');
    });
    if (hp) hp.removeAttribute('name');

    remember({ submitted: true });

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', { form: 'Exit popup', page_path: window.location.pathname });
    }

    if (btn) {
      btn.setAttribute('disabled', 'disabled');
      var label = btn.querySelector('.mav-exit__btn-label');
      if (label) label.textContent = 'Sending…';
    }
  });

  window.addEventListener('pageshow', function (evt) {
    if (!evt.persisted || !btn) return;
    btn.removeAttribute('disabled');
    var label = btn.querySelector('.mav-exit__btn-label');
    if (label) label.textContent = 'Get my quote';
  });
})();
